"use strict";

exports.__esModule = true;
exports.numericValidator = exports.VALIDATOR_TYPE = void 0;
var _numericValidator = require("./numericValidator");
exports.VALIDATOR_TYPE = _numericValidator.VALIDATOR_TYPE;
exports.numericValidator = _numericValidator.numericValidator;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/numericValidator/index.js
// module id = 597
// module chunks = 0